export default __webpack_public_path__ + "static/media/Shot_2.0000.92367b66.png";